import React, { useState, useEffect } from 'react';
import ChatWebSocketService from '../services/ChatWebSocketService';
import './WebSocketStatus.css';

interface WebSocketStatusProps {
  className?: string;
}

const WebSocketStatus: React.FC<WebSocketStatusProps> = ({ className = '' }) => {
  const [status, setStatus] = useState<'connecting' | 'connected' | 'disconnected' | 'error'>('disconnected');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Atualizar status inicial
    setStatus(ChatWebSocketService.connectionStatus);

    // Listener para mudanças de status
    const handleStatusChange = (event: CustomEvent) => {
      const { status: newStatus } = event.detail;
      setStatus(newStatus);
      
      // Só mostrar indicador para erros persistentes (não para desconexões temporárias)
      // e apenas se não estiver conectado por mais de 10 segundos
      if (newStatus === 'error') {
        setTimeout(() => {
          if (ChatWebSocketService.connectionStatus === 'error') {
            setIsVisible(true);
          }
        }, 10000);
      } else if (newStatus === 'connected') {
        setIsVisible(false);
      }
    };

    window.addEventListener('websocketStatusChange', handleStatusChange as EventListener);

    // Verificar status periodicamente
    const interval = setInterval(() => {
      const currentStatus = ChatWebSocketService.connectionStatus;
      if (currentStatus !== status) {
        setStatus(currentStatus);
        // Só mostrar se for erro persistente
        if (currentStatus === 'error') {
          setTimeout(() => {
            if (ChatWebSocketService.connectionStatus === 'error') {
              setIsVisible(true);
            }
          }, 10000);
        } else if (currentStatus === 'connected') {
          setIsVisible(false);
        }
      }
    }, 5000);

    return () => {
      window.removeEventListener('websocketStatusChange', handleStatusChange as EventListener);
      clearInterval(interval);
    };
  }, [status]);

  const getStatusInfo = () => {
    switch (status) {
      case 'connecting':
        return {
          text: 'Conectando...',
          color: '#f59e0b',
          icon: '🔄'
        };
      case 'connected':
        return {
          text: 'Conectado',
          color: '#0C85BA',
          icon: '✅'
        };
      case 'disconnected':
        return {
          text: 'Desconectado',
          color: '#6b7280',
          icon: '❌'
        };
      case 'error':
        return {
          text: 'Erro de conexão',
          color: '#ef4444',
          icon: '⚠️'
        };
      default:
        return {
          text: 'Desconhecido',
          color: '#6b7280',
          icon: '❓'
        };
    }
  };

  const handleReconnect = () => {
    ChatWebSocketService.forceReconnect();
  };

   // Nunca mostrar o componente
  return null;
};

export default WebSocketStatus; 